export default __webpack_public_path__ + "static/media/Hands_Pink.5b95368d.png";